export default "__VITE_ASSET__BEQh0mpS__"